import { hbs } from 'ember-cli-htmlbars';
export default hbs("<footer\n  class={{class-names \"bv-modal__footer\" (if @sticky \"bv-modal__footer--sticky\")}}\n  ...attributes\n>\n  {{yield}}\n</footer>")